<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="36" height="36" viewBox="0 0 36 36">
        <defs>
            <clipPath id="clip-Manufacturer">
                <rect width="36" height="36"/>
            </clipPath>
        </defs>
        <g id="Manufacturer" clip-path="url(#clip-Manufacturer)">
            <rect width="36" height="36" class="svg-block-background-color"/>
            <g id="Group_2" data-name="Group 2" transform="translate(7378.76 -627.586)">
                <rect id="Rectangle_10110" data-name="Rectangle 10110" width="36" height="36" transform="translate(-7378.76 627.586)" fill="#263238" opacity="0"/>
                <path id="Path_4343" :class="secondaryColor" data-name="Path 4343" d="M-7354.407,633.409v15.353l-3.971-6.353-2.912,4.659-2.912-4.659-2.912,4.659-2.912-4.659-3.971,6.353v9h26.471V633.409Z"/>
            </g>
        </g>
    </svg>

</template>

<script>
export default {
    name: "manufacturerIcon",
    computed :{
        secondaryColor() {
            return 'svg-secondary-color';
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/info-popup/manufacturerIcon.vue